import React, { useMemo } from 'react';

function App() {
  // Generate fishes for background animation
  const fishes = useMemo(
    () =>
      Array.from({ length: 8 }).map(() => ({
        top: Math.random() * 100,
        duration: 6 + Math.random() * 8,
        delay: Math.random() * 4,
        size: 30 + Math.random() * 40,
      })),
    []
  );

  // Assets URLs
  const backgroundUrl = 'https://brokepiggytoken.xyz/wp-content/uploads/2025/04/mgl-jpk-m062-28618.webp';
  const blubLogo = 'https://brokepiggytoken.xyz/wp-content/uploads/2025/04/BlubClub-1.png';
  const launchLogo = 'https://brokepiggytoken.xyz/wp-content/uploads/2025/04/crowdlaunch-lnch.png';
  const listingLink = 'https://app.crowdlaunch.xyz/tokenize/?projects=BlubClub';

  // Background overlay style
  const backgroundStyle = {
    position: 'fixed', top: 0, left: 0,
    width: '100%', height: '100%',
    backgroundImage: `url(${backgroundUrl})`,
    backgroundSize: 'cover', backgroundPosition: 'center',
    opacity: 1, // lighter overlay
    pointerEvents: 'none', zIndex: 0,
  };

  return (
    <div style={styles.container}>
      <div style={backgroundStyle} />

      <div style={styles.fishContainer}>
        {fishes.map((fish, i) => (
          <div
            key={i}
            style={{
              ...styles.fish,
              top: `${fish.top}%`, fontSize: `${fish.size}px`,
              animation: `swim ${fish.duration}s linear infinite`,
              animationDelay: `${fish.delay}s`,
            }}
          >🐟</div>
        ))}
      </div>

      <div style={styles.sections}>
        {/* Hero Section */}
        <section style={{ ...styles.section, background: 'rgba(255,255,255,0.3)' }}>
          <img
            src={blubLogo}
            alt="BlubClub Logo"
            style={styles.logoLarge}
            className="fadeUp"
          />
          <p style={styles.subtitle} className="fadeUp delay1">
            A memecoin to send to people when all you hear when they speak is "BLUB, BLUB, BLUB".
          </p>
          <a href={listingLink} target="_blank" rel="noopener noreferrer" style={styles.badge} className="fadeUp delay2">
            <img src={launchLogo} alt="CrowdLaunch Logo" style={styles.launchLogo} />
            <span style={styles.badgeText}>Listed on CrowdLaunch</span>
          </a>
        </section>

        {/* About Section */}
        <section style={{ ...styles.section, background: 'rgba(0,188,212,0.3)' }}>
          <img
            src={blubLogo}
            alt="BlubClub Logo"
            style={styles.logoSmall}
            className="fadeUp"
          />
          <h2 style={styles.sectionTitle} className="fadeUp delay1">
            About BlubClub
          </h2>
          <p style={styles.text} className="fadeUp delay2">
            BlubClub is a playful token that lets you express fishy vibes. Whenever someone
            sounds like they're bubbling underwater, send them BLB and let the Blub Culture spread!
          </p>
        </section>

        {/* Objectives Section */}
        <section style={{ ...styles.section, background: 'rgba(255,235,59,0.3)' }}>
          <h2 style={styles.sectionTitle} className="fadeUp">
            Objectives
          </h2>
          <ul style={styles.list}>
            <li className="fadeUp delay1">
              🐠 20% of funds go to water cleaning organizations
            </li>
            <li className="fadeUp delay2">
              🌊 80% goes to liquidity
            </li>
          </ul>
        </section>

        {/* Buy Section */}
        <section style={{ ...styles.section, background: 'rgba(156,39,176,0.3)' }}>
          <h2 style={styles.sectionTitle} className="fadeUp">
            Join the Blub Revolution
          </h2>
          <a
            href={listingLink}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.button}
            className="fadeUp delay1"
          >
            🐠 Buy BLB on Crowdlaunch
          </a>
          <a href={listingLink} target="_blank" rel="noopener noreferrer" style={styles.badge} className="fadeUp delay2">
            <img src={launchLogo} alt="CrowdLaunch Logo" style={styles.launchLogo} />
            <span style={styles.badgeText}>Listed on CrowdLaunch</span>
          </a>
        </section>
      </div>

      <style>{`
        @keyframes swim { from { transform: translateX(-10vw); } to { transform: translateX(110vw); }}
        .fadeUp { opacity: 0; transform: translateY(20px); animation: fadeUp 0.8s forwards; }
        .delay1 { animation-delay: 0.4s; } .delay2 { animation-delay: 0.8s; }
        @keyframes fadeUp { to { opacity: 1; transform: translateY(0); }}
        div::-webkit-scrollbar { display: none; }
      `}</style>
    </div>
  );
}

const styles = {
  container: { position: 'relative', width: '100vw', height: '100vh', overflowY: 'scroll', scrollSnapType: 'y mandatory' },
  fishContainer: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', overflow: 'hidden', pointerEvents: 'none', zIndex: 1 },
  fish: { position: 'absolute' },
  sections: { position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column' },
  section: { scrollSnapAlign: 'start', height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '20px', textAlign: 'center' },

  logoLarge: { width: '400px', marginBottom: '1rem' },
  logoSmall: { width: '150px', marginBottom: '1rem' },

  badge: {
    display: 'flex', alignItems: 'center', background: 'rgba(255,255,255,0.9)', padding: '10px 20px', borderRadius: '30px', marginTop: '1rem', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', textDecoration: 'none'
  },
  launchLogo: { width: '50px', marginRight: '10px' },
  badgeText: { fontSize: '1rem', fontWeight: 'bold', color: '#000' },

  sectionTitle: { fontSize: '2.5rem', marginBottom: '1rem' },
  subtitle: { fontSize: '1.5rem', marginTop: '1rem', maxWidth: '600px' },
  text: { fontSize: '1.2rem', maxWidth: '600px', lineHeight: 1.5 },
  list: { listStyle: 'none', padding: 0, fontSize: '1.2rem', lineHeight: 2 },
  button: { display: 'inline-block', padding: '15px 30px', textDecoration: 'none', fontSize: '1.2rem', borderRadius: '8px', background: '#00bcd4', color: '#fff', marginTop: '1rem' },
};

export default App;
